export default __webpack_public_path__ + "static/media/BasisGrotesquePro-Regular.20831b73.woff";